import { connect } from 'react-redux'
import { setErrorMessage, setModal, notify } from 'actions/account'

const mapStateToProps = () => ({})
const actions = { setErrorMessage, setModal, notify }

const withRedux = connect(mapStateToProps, actions)

export default withRedux
